import '@/shared/locales/i18next-init.tsx'
import type { PropsWithChildren } from 'react'

export function I18nProvider({ children }: Readonly<PropsWithChildren>) {
	return children
}
